import React, { useEffect, useCallback } from "react";
import { useRouter } from "next/router";
import { Box, Typography } from "@bca/ui-library";
import { FilterAsCheckbox } from "./FilterAsCheckbox";
import addFiltersToPageUrl from "./addFiltersToPageUrl";
import SelectGroup from "./SelectGroup";
import { filterDisclaimers } from "./filtersConfig";

let timer;

const MileageFilter = ({
  appliedCheckboxes,
  setAppliedCheckboxes,
  setSelectedVehicles,
  rangeSubfilters,
  searchResultsLoading,
}) => {
  const router = useRouter();

  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const newUrl = addFiltersToPageUrl("bq", appliedCheckboxes);
      const currentPageUrl = new URL(window.location.href);
      if (newUrl.href === currentPageUrl.href) {
        return;
      }
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("vrm");
      router.push(newUrl.href, newUrl.href, { shallow: true });
    }, 1000);
  }, [appliedCheckboxes, router]);

  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);

  const onChangeMileageWarranted = (categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;

    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: "true",
          categoryKey: "MileageWarranted",
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  const onChangeMileageUnknown = (categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;

    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey === categoryKey
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: "false",
          categoryKey: "missingMileage",
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  const onSelectChange = (filterKey, categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;
    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) => item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    newState = [
      ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      {
        filterKey: filterKey,
        categoryKey,
        groupedBy: "",
        parentFilterKey: "",
      },
    ];

    setAppliedCheckboxes([...newState]);
  };

  const firstCheckbox = "MileageWarranted";
  const secondCheckbox = "MissingMileage";
  const disclaimerText = filterDisclaimers.find(
    (item) =>
      item.categoryKey === "Mileage" && item.filterKey === "Mileage Known"
  )?.disclaimerText;

  return (
    <Box>
      {rangeSubfilters && (
        <SelectGroup
          rangeSubfilters={rangeSubfilters}
          categoryKey="Mileage"
          onChange={onSelectChange}
          searchResultsLoading={searchResultsLoading}
          appliedCheckboxes={appliedCheckboxes}
          labels={["From", "To"]}
        ></SelectGroup>
      )}
      <Box mt={5}>
        <Box>
          <FilterAsCheckbox
            key={firstCheckbox}
            id={firstCheckbox}
            label="Must be warranted mileage"
            isSelected={Boolean(
              appliedCheckboxes.find(
                (item) =>
                  (item.categoryKey === "MileageWarranted" ||
                    item.categoryKey === "mileagewarranted") &&
                  item.filterKey === "true"
              )
            )}
            onChange={() => onChangeMileageWarranted("MileageWarranted")}
          />
        </Box>
        <Box>
          <FilterAsCheckbox
            key={secondCheckbox}
            id={secondCheckbox}
            label="Include vehicles with unknown mileage"
            isSelected={
              !Boolean(
                appliedCheckboxes.find(
                  (item) =>
                    item.categoryKey === "missingMileage" &&
                    item.filterKey === "false"
                )
              )
            }
            onChange={() => onChangeMileageUnknown("missingMileage")}
          />
          {disclaimerText && (
            <Typography
              color="grey-blue"
              variant="caption"
              fontWeight="light"
              ml={9}
              css={`
                max-width: 292px;
              `}
            >
              {disclaimerText}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default MileageFilter;
